export const fetchCharts = () => {
  const charts = [
    {
      id: 1,
      title: 'Revenue (USD)',
      x: 1,
      y: 1,
      width: 6,
      height: 1,
      query: {
        measures: ['invoices.invoice__sub_total_sum'],
        timeDimensions: [
          {
            dimension: 'invoices.invoice__rendered_time',
            granularity: 'month',
            dateRange: 'from 1 year ago to now',
          },
        ],
        filters: [
          {
            member: 'invoices.invoice__rendered_time',
            operator: 'set',
          },
        ],
        order: {
          'invoices.invoice__rendered_time': 'desc',
        },
      },
    },
    {
      id: 2,
      title: 'Utilization (%)',
      x: 7,
      y: 1,
      width: 6,
      height: 1,
      query: {
        measures: [
          'utilization.utilization__vehicle_utilization',
          'utilization.utilization__vehicle_other_services_utilization',
        ],
        timeDimensions: [
          {
            dimension: 'utilization.utilization__period_start',
            granularity: 'month',
            dateRange: 'from 1 year ago to now',
          },
        ],
        order: {
          'utilization.utilization__period_start': 'desc',
        },
      },
      alias: ['This org', 'Other orgs'],
    },
    {
      id: 3,
      title: 'Margin (USD)',
      x: 1,
      y: 2,
      width: 4,
      height: 1,
      query: {
        measures: ['invoices.invoice__margin'],
        timeDimensions: [
          {
            dimension: 'invoices.invoice__rendered_time',
            granularity: 'month',
            dateRange: 'from 1 year ago to now',
          },
        ],
        filters: [
          {
            member: 'invoices.invoice__rendered_time',
            operator: 'set',
          },
        ],
        order: {
          'invoices.invoice__rendered_time': 'desc',
        },
      },
    },
    {
      id: 4,
      title: 'Direct Cost (USD)',
      x: 5,
      y: 2,
      width: 4,
      height: 1,
      query: {
        measures: ['invoices.invoice__direct_costs'],
        timeDimensions: [
          {
            dimension: 'invoices.invoice__rendered_time',
            granularity: 'month',
            dateRange: 'from 1 year ago to now',
          },
        ],
        filters: [
          {
            member: 'invoices.invoice__rendered_time',
            operator: 'set',
          },
        ],
        order: {
          'invoices.invoice__rendered_time': 'desc',
        },
      },
    },
    {
      id: 5,
      title: 'Uptime (%)',
      x: 9,
      y: 2,
      width: 4,
      height: 1,
      query: {
        measures: ['utilization.utilization__vehicle_all_services_uptime'],
        timeDimensions: [
          {
            dimension: 'utilization.utilization__period_start',
            granularity: 'month',
            dateRange: 'from 1 year ago to now',
          },
        ],
        order: {
          'utilization.utilization__period_start': 'desc',
        },
      },
    },
  ];

  return charts;
};
